import { Dropdown } from 'semantic-ui-react';
import { Project } from '~/types/project';
import { Link, useLocation } from 'react-router-dom';
import { usePortfolioContext, useProjectContext } from '~/hooks';
import { usePermissions } from '~/requests/permissions/usePermissions';
import { ProjectStatus } from '~/constants/statuses';

export default function PortfolioProjectSwitcher() {
  const { permissions } = usePermissions();
  let { portfolio } = usePortfolioContext();
  const { project } = useProjectContext();
  const location = useLocation();

  portfolio = project?.portfolio ?? portfolio;
  if (!portfolio?.projects?.length) {
    return null;
  }

  const [,,, ...urlParts] = location.pathname.split('/');
  const urlPath = urlParts?.join('/') + location.search;

  // Investors should not see projects they're no longer in the running for — their data rooms
  // are blocked server-side (see verifyDataroomAccess), so the switcher entry would just 404/403.
  const isInvestorView = !permissions.hasProjectDeveloperAccess && !permissions.isAdmin;

  const projectList = portfolio?.projects
    ?.filter((p: Project) => {
      if (permissions.hasProjectDeveloperAccess) {
        return !p.parentId || p.id === p.parentId || p.childSelected;
      }
      if (isInvestorView && (p.status === ProjectStatus.DECLINED_TO_BID || p.status === ProjectStatus.BID_REJECTED)) {
        return false;
      }
      return true;
    })
    ?.sort((a: Project, b: Project) => a?.name?.localeCompare(b?.name));

  return (
    <Dropdown
      trigger={'Switch data room'}
      selection
      compact
      style={{ fontSize: '14px'}}
    > 
    <Dropdown.Menu style={{ width: '15.5rem', minWidth: 'auto' }}>
      <Dropdown.Item
        as={Link}
        to={`/portfolio/${portfolio?.id}/${urlPath}`}
        key={`portfolio-${portfolio?.id}`}
        style={{ whiteSpace: 'normal' }}
      >
        Portfolio-level documents
      </Dropdown.Item>
      {projectList.map((project: Project) => (
        <Dropdown.Item
          as={Link}
          to={`/project/${project?.id}/${urlPath}`}
          key={`project-${project.id}`}
          style={{ whiteSpace: 'normal' }}
        >
          {project?.name}
        </Dropdown.Item>
      ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}